import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPcodeMaster } from 'sales-types-common';

interface PCodeMasterListState {
  pCodeMasterList: IPcodeMaster[];
  pCodeMasterData: IPcodeMaster[];
}

const initialState: PCodeMasterListState = {
  pCodeMasterList: [],
  pCodeMasterData: [],
};

const pCodeMasterListSlice = createSlice({
  name: 'pCodeMasterList',
  initialState,
  reducers: {
    setPCodeMasterList: (state, action: PayloadAction<IPcodeMaster[]>) => {
      state.pCodeMasterList = action.payload;
    },
    setPCodeMasterData: (state, action: PayloadAction<IPcodeMaster[]>) => {
      state.pCodeMasterData = action.payload;
    },
  },
});

export const { setPCodeMasterList, setPCodeMasterData } = pCodeMasterListSlice.actions;
export default pCodeMasterListSlice.reducer;
